import { Controller, useFormContext } from 'react-hook-form'
import { Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import './labRemarksSection.less'

const { TextArea } = Input

const MAX_LENGTH = 2047
const MAX_LINES = 15

const LabRemarksSection = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <div className="lab-card lab-remarks">
      <div className="lab-card__header">
        {t('rob.survey.bunker.lab.remarks.title')}
      </div>
      <Controller
        control={control}
        name="laboratory.remarks"
        render={({ field: { onChange, value, ...rest } }) => {
          const charCount = (value ?? '').length

          const handleChange = e => {
            let val = e.target.value

            // Enforce line limit
            const lines = val.split('\n')
            if (lines.length > MAX_LINES) {
              val = lines.slice(0, MAX_LINES).join('\n')
            }

            // Enforce char limit
            if (val.length > MAX_LENGTH) {
              val = val.slice(0, MAX_LENGTH)
            }

            onChange(val)
          }

          return (
            <div className="lab-remarks__body">
              <TextArea
                {...rest}
                className="lab-remarks__textarea"
                maxLength={MAX_LENGTH}
                onChange={handleChange}
                placeholder={t('rob.survey.bunker.lab.remarks.placeholder')}
                rows={1}
                value={value ?? ''}
              />
              <span className="lab-remarks__counter">
                {charCount}/{MAX_LENGTH}
              </span>
            </div>
          )
        }}
      />
    </div>
  )
}

export default LabRemarksSection
